'use client';

import { Button } from '@savvy-kit/components/button';
import { cn } from '@savvy-kit/lib/utils';
import { Share } from 'lucide-react';

import type { ExportButtonSlotProps } from '../../types/export-slots';

export type DataTableExportButtonProps = ExportButtonSlotProps & React.ComponentProps<typeof Button>;

export function DataTableExportButton({ disabled, onClick, className, ...props }: DataTableExportButtonProps) {
  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={onClick}
      disabled={disabled}
      className={cn('ml-auto', className)}
      {...props}
    >
      <Share />
      Export to CSV
    </Button>
  );
}
